/**
 * Why a contact is skipped by a broadcast, in the owner's words (spec P-3.7).
 *
 * The sidecar sends a CODE with every skipped contact (`no_phone`, `unusable_phone`,
 * `suppressed`, `render_failed`) beside its English sentence. The code picks the sentence here;
 * a reason with no code (a sample stored before codes existed) or with one this screen does not
 * know is shown as the sidecar wrote it, which is how it always read.
 */
const CODE_KEYS = {
  no_phone: 'NO_PHONE',
  unusable_phone: 'UNUSABLE_PHONE',
  suppressed: 'SUPPRESSED',
  render_failed: 'RENDER_FAILED',
};

/**
 * @param {{ reason: string, code?: string }} reason One of `preview.skipReasons`.
 * @param {(key: string) => string} t
 */
export const skipReasonText = (reason, t) => {
  const code = reason?.code;
  return typeof code === 'string' && Object.hasOwn(CODE_KEYS, code)
    ? t(`WASLO.BROADCASTS.COMPOSE.CHECK.SKIP_CODE.${CODE_KEYS[code]}`)
    : String(reason?.reason ?? '');
};

export default skipReasonText;
